
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Familyresortnearbuldhana() {



  const cardData =
  {
    keyword: ' Family Resorts Near Buldhana',
    heading:  'Woodland Escape: Family Resorts Near Buldhana ',
    headingDescription: 'Woodland Escape Resort is one of the finest family resorts near Buldhana, offering a perfect blend of comfort, nature, and togetherness for families seeking a peaceful getaway. Surrounded by lush greenery, open lawns, and serene forest views, the resort provides an inviting atmosphere where parents can relax while children play freely in safe outdoor spaces. Guests can enjoy refreshing nature walks, fun games, delicious homemade meals, and cozy cottages designed for family comfort. With warm hospitality, modern amenities, and plenty of space for bonding and laughter, Woodland Escape Resort near Buldhana ensures every family visit becomes a heartwarming experience filled with joy, relaxation, and beautiful memories in nature’s embrace.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Family Resorts Near Buldhana",
      "description": "Discover the best family resorts near Buldhana offering comfort, scenic surroundings, and modern amenities for a perfect family getaway. These resorts provide spacious rooms, lush gardens, swimming pools, and recreational activities suitable for all age groups. Enjoy quality time with your loved ones amidst nature, with options for indoor games, outdoor adventures, and delicious multi-cuisine dining."
    },
    {
      "name": "Buldhana Family Stay Resort",
      "description": "Experience a peaceful stay at Buldhana family resorts designed for comfort, relaxation, and togetherness. With family suites, kids’ play areas, and serene landscapes, these resorts ensure an enjoyable vacation for every member. Ideal for weekend stays, get-togethers, or small celebrations, the resorts blend hospitality with a homely atmosphere for a memorable family retreat."
    },
    {
      "name": "Affordable Family Resorts Buldhana",
      "description": "Explore budget-friendly family resorts in Buldhana that provide a luxurious experience without the heavy price tag. Enjoy clean, comfortable accommodations, outdoor lawns, children’s play zones, and complimentary breakfast. Perfect for families seeking a relaxing escape that fits every budget while still enjoying great service, scenic beauty, and relaxation."
    },
    {
      "name": "Buldhana Weekend Family Resort",
      "description": "Plan your perfect weekend escape to a family resort in Buldhana offering leisure, comfort, and entertainment for all ages. These weekend resorts feature fun activities, refreshing pools, and nature walks that make short breaks truly rejuvenating. Whether you prefer quiet relaxation or energetic outdoor games, Buldhana’s weekend resorts have something for everyone."
    },
    {
      "name": "Buldhana Kids Friendly Resort",
      "description": "Enjoy a stress-free vacation at Buldhana’s kid-friendly resorts equipped with safe play zones, family pools, and engaging activities for children. Parents can unwind while kids enjoy supervised fun in a safe and joyful environment. With spacious rooms and family-oriented dining, these resorts promise a balanced mix of comfort and entertainment for the whole family."
    },
    {
      "name": "Buldhana Family Outing Resort",
      "description": "Host your next family outing at one of Buldhana’s top resorts featuring open lawns, picnic areas, and outdoor activity zones. Ideal for day trips, birthdays, or weekend picnics, these resorts offer delicious meals, adventure activities, and peaceful ambiance. Enjoy bonding time, laughter, and fun-filled games in a natural and relaxing setting."
    },
    {
      "name": "Buldhana Nature Resort for Families",
      "description": "Reconnect with nature at Buldhana’s family nature resorts surrounded by greenery, hills, and rivers. Perfect for families seeking tranquility and outdoor fun, these resorts offer nature walks, bird watching, and eco-friendly accommodations. Experience fresh air, peaceful landscapes, and quality family time away from the city noise."
    },
    {
      "name": "Buldhana Riverside Family Resort",
      "description": "Relax by the water at a riverside family resort in Buldhana, offering stunning views, boating options, and riverside dining. These resorts are ideal for peaceful getaways where families can enjoy morning walks along the river, picnics by the banks, and serene sunsets. With modern facilities and natural beauty, it’s a perfect blend of comfort and charm."
    },
    {
      "name": "Buldhana Hill Resort for Family",
      "description": "Enjoy the cool breezes and panoramic views at Buldhana’s hill resorts, ideal for families looking to escape into nature. Spend your days trekking, sightseeing, or simply relaxing amid the hills. These hilltop resorts provide comfortable stays, fresh meals, and scenic backdrops that make every family moment memorable and refreshing."
    },
    {
      "name": "Buldhana Family Picnic Resort",
      "description": "Spend a joyful day at a family picnic resort in Buldhana, complete with open spaces, gardens, and outdoor activities. Perfect for day-long gatherings, these resorts offer catering options, shaded seating, and fun amenities like volleyball, cricket, and barbeque areas. Ideal for those who wish to combine relaxation with family fun and outdoor recreation."
    },
    {
      "name": "Buldhana Outdoor Family Resort",
      "description": "Discover Buldhana’s best outdoor family resorts where adventure and leisure come together. Enjoy open-air dining, bonfire nights, sports activities, and nature-inspired stays. These resorts are perfect for families who love exploring the outdoors while staying in comfort and style amidst lush landscapes."
    },
    {
      "name": "Buldhana Group Family Resort",
      "description": "Plan a group getaway at Buldhana’s family resorts that cater to large families and gatherings. With banquet spaces, multiple cottages, and group dining facilities, these resorts are ideal for reunions and celebrations. Spend your time bonding over outdoor games, live music, and shared meals in a lively yet peaceful environment."
    },
    {
      "name": "Buldhana Family Resort Booking",
      "description": "Easily book your family resort in Buldhana with online reservation options offering detailed packages, flexible dates, and seasonal discounts. Choose from riverside, nature, or luxury resorts and secure your booking in minutes. Get confirmed stays, great deals, and hassle-free arrangements for your next family getaway."
    },
    {
      "name": "Buldhana One Day Family Resort",
      "description": "Looking for a short yet refreshing outing? Visit a one-day family resort in Buldhana featuring swimming pools, garden areas, and delicious food. Perfect for a quick break, these resorts offer all the fun of a vacation without the overnight stay. Ideal for busy families who want to recharge and reconnect over a single day of relaxation and enjoyment."
    },
    {
      "name": "Buldhana Luxury Family Resort",
      "description": "Indulge in elegance at Buldhana’s luxury family resorts offering premium amenities, fine dining, spa services, and world-class hospitality. Perfect for families who prefer a blend of comfort and sophistication, these resorts ensure every detail—from decor to cuisine—is tailored for a high-end experience. Enjoy a lavish escape where relaxation meets refinement."
    }
  ],
  "tableData": [
    ["- Family Resorts Near Buldhana", "- Buldhana Family Stay Resort"],
    ["- Affordable Family Resorts Buldhana", "- Buldhana Weekend Family Resort"],
    ["- Buldhana Kids Friendly Resort", "- Buldhana Family Outing Resort"],
    ["- Buldhana Nature Resort for Families", "- Buldhana Riverside Family Resort"],
    ["- Buldhana Hill Resort for Family", "- Buldhana Family Picnic Resort"],
    ["- Buldhana Outdoor Family Resort", "- Buldhana Group Family Resort"],
    ["- Buldhana Family Resort Booking", "- Buldhana One Day Family Resort"],
    ["- Buldhana Luxury Family Resort", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Best Family Resort Near Buldhana",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect getaway for families near Buldhana. Surrounded by lush greenery and peaceful surroundings, it offers a safe and enjoyable space where families can relax, play, and bond together."
  },
  {
    "WhyChooseheading": "Peaceful and Natural Surroundings",
    "WhyChoosedescription": "Nestled amidst beautiful forest landscapes, the resort provides a serene environment ideal for quality family time. Enjoy the calmness of nature while your loved ones experience the soothing sounds of birds and rustling leaves."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Stay Options",
    "WhyChoosedescription": "Woodland Escape Resort features comfortable rooms and cottages designed for families. With ample space and modern amenities, it ensures a relaxed and pleasant stay for everyone."
  },
  {
    "WhyChooseheading": "Fun Activities for All Ages",
    "WhyChoosedescription": "The resort offers a variety of family-friendly activities such as cycling, outdoor games, nature walks, and pond-side relaxation. Both kids and adults can enjoy fun-filled moments together in a safe environment."
  },
  {
    "WhyChooseheading": "Perfect for Weekend Family Getaways",
    "WhyChoosedescription": "Whether it’s a short weekend escape or a full-day trip, Woodland Escape Resort provides the ideal destination for families looking to unwind and reconnect away from the city noise."
  },
  {
    "WhyChooseheading": "Delicious and Fresh Food Options",
    "WhyChoosedescription": "Families can enjoy freshly prepared local meals, snacks, and refreshing beverages. The resort’s food services ensure that your stay is as tasty as it is relaxing."
  },
  {
    "WhyChooseheading": "Convenient Location Near Buldhana",
    "WhyChoosedescription": "Located just a short drive from Buldhana, Woodland Escape Resort is easy to reach, making it the go-to family resort for those who want a quick yet fulfilling nature retreat."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort one of the best family resorts near Buldhana?",
    answer: "Woodland Escape Resort is known for its serene atmosphere, beautiful landscapes, and family-friendly environment. It’s the ideal place where families can relax, play, and spend quality time together near Buldhana."
  },
  {
    question: "How far is Woodland Escape Resort from Buldhana city?",
    answer: "The resort is approximately 35–40 km from Buldhana, easily accessible within 1 to 1.5 hours by car. Its convenient location makes it perfect for family outings and weekend stays."
  },
  {
    question: "What facilities are available for families at Woodland Escape Resort?",
    answer: "Families can enjoy spacious lawns, kids’ play areas, outdoor games, nature walks, and relaxing picnic zones. The resort ensures comfort and entertainment for guests of all ages."
  },
  {
    question: "Is Woodland Escape Resort safe and suitable for children?",
    answer: "Yes, the resort is completely family-friendly with safe surroundings, clean spaces, and dedicated play areas for kids. Parents can relax while children enjoy themselves safely."
  },
  {
    question: "Does the resort provide food and refreshments for families?",
    answer: "Yes! Woodland Escape Resort offers delicious, freshly prepared meals, snacks, and beverages. Family packages can include lunch and refreshments for a comfortable experience."
  },
  {
    question: "How can we book our stay or family picnic at Woodland Escape Resort near Buldhana?",
    answer: "You can easily book by calling or sending a WhatsApp message to our reservation team, or by visiting the official website. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Ramesh & Family, Buldhana",
    text: "Woodland Escape Resort is truly one of the best family resorts near Buldhana. The kids loved the play area, and we enjoyed the greenery and peaceful vibe. Perfect family weekend spot!"
  },
  {
    name: "Mrs. Priya & Family, Buldhana",
    text: "Our stay at Woodland Escape Resort was wonderful! The place is clean, safe, and full of natural beauty. Great food and a very friendly environment for families."
  }
];


















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Resorts Near Buldhana",
  "image": "https://woodlandescape.com/assets/images/family-resorts-buldhana.jpg",
  "description": "Enjoy a perfect family getaway at Woodlandescape Resort, one of the best family resorts near Buldhana. Ideal for weekend trips with kids, scenic nature, riverside views, outdoor activities, and comfortable stays.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "245"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-resorts-buldhana"
  }
};



  return (
    <div>
<Helmet>
  <title>Family Resorts Near Buldhana | Scenic & Comfortable Stay | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a memorable family getaway at Woodlandescape Resort, one of the best family resorts near Buldhana. Enjoy scenic nature, riverside views, outdoor activities, and comfortable stays perfect for weekends with kids." 
  />
  <meta 
    name="keywords" 
    content="Family Resorts Near Buldhana, Buldhana Family Stay Resort, Affordable Family Resorts Buldhana, Buldhana Weekend Family Resort, Buldhana Kids Friendly Resort, Buldhana Family Outing Resort, Buldhana Nature Resort for Families, Buldhana Riverside Family Resort, Buldhana Hill Resort for Family, Buldhana Family Picnic Resort, Buldhana Outdoor Family Resort, Buldhana Group Family Resort, Buldhana Family Resort Booking, Buldhana One Day Family Resort, Buldhana Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/22.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Familyresortnearbuldhana;